export enum JobType {
    CONTRACT = 4,
    FULLTIME = 1,
    LOCUM = 7,
    LOCUM_FULLTIME = 8,
    PARTTIME = 2,
    PRORENATA = 5,
    TEMPORARY = 3
};
